import { render, staticRenderFns } from "./RootLayout.vue.js?vue&type=template&id=90800d76!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RootLayout.vue?vue&type=template&id=90800d76"
import script from "./RootLayout.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RootLayout.vue?vue&type=script&lang=js"
export * from "./RootLayout.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RootLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports